<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-3">{{'Họ và tên' | translate}}</label>
      <div class="col-9">
        <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.HoVaTen">
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3">{{'Điện thoại' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DienThoai">
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3">{{'Năm sinh' | translate}}</label>
      <div class="col-9">
        <input class="form-control"
               maxlength="20"
               tabindex="8"
               currencyMask
               [(ngModel)]="doituongSelect.NamSinh"
               name="value"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>

   
    <div class="row form-group">
      <label class="control-label col-3">{{'Học lực' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="13" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu">
      </div>
    </div>

   


    <div class="row form-group"  *ngIf="tudanhsach==1">
      <label class="control-label col-3">{{'Nội dung tư vấn' | translate}}</label>
      <div class="col-9">
        <ejs-richtexteditor style="background-color:white" height='250px' #toolsRTE id='alltoolRTE_ch' [toolbarSettings]='tools' [showCharCount]='true' [(value)]='doituongSelect.NoiDungTuVan'
                            [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'
                            (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
        </ejs-richtexteditor>

      </div>
    </div>








  </div>

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> {{'Đã xử lý xong' | translate}}
      </label>
    </div>
  </div>

  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>


<!--<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)">
    </ejs-filemanager>
  </ejs-dialog>
</div>-->
